import { render, staticRenderFns } from "./WhatsAppGroup.vue?vue&type=template&id=42939bfb&"
import script from "./WhatsAppGroup.vue?vue&type=script&lang=js&"
export * from "./WhatsAppGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports